<template>
  <div class="apply-info x-margin x-border-50">
    <my-head-title :title="$t('HT.accessInfo.title')"></my-head-title>
    <div class="ul-item x-padding-info">
      <my-info-item :title="$t('HT.addLicense.userName')" :info="formData.title"></my-info-item>
      <my-info-item :title="$t('HT.addLicense.sales')" :info="formData.sales"></my-info-item>
      <my-info-item :title="$t('HT.addLicense.engineer')" :info="formData.engineer"></my-info-item>
      <my-info-item :title="$t('HT.addLicense.expireDate')">
        <span>{{ formatterTime(formData.expire_date) }}</span>
        <ux-button
          v-if="this.userData.supervisor"
          type="text"
          class="button-space"
          @click="renewal(formData)"
          >{{ $t('HT.licenseInfo.renewal') }}</ux-button
        >
      </my-info-item>
      <my-info-item title="License" :info="formData.reg_code"></my-info-item>
      <my-info-item :title="$t('HT.addLicense.maxHosts')" :info="formData.max_hosts"></my-info-item>
      <my-info-item :title="$t('HT.rebind.mac')" :optionText="false">
        <span>{{ mac_array }}</span>
        <ux-button
          v-if="this.userData.supervisor"
          type="text"
          class="button-space"
          @click="rebind(id)"
          >{{ $t('HT.unbind') }}</ux-button
        >
      </my-info-item>
      <my-info-item :title="$t('HT.addLicense.maxConn')" :info="formData.max_conn"></my-info-item>
      <my-info-item :title="$t('HT.licenseInfo.describe')" start :line="5" class="describe">
        <span v-for="(item, i) in this.formData.extension"
          ><template v-if="item">{{ i }}: {{ item }}&nbsp;&nbsp;</template></span
        >
      </my-info-item>
    </div>
  </div>
</template>

<script>
import renewal from './template/renewal';
import rebind from './template/rebind';
export default {
  components: {
    renewal,
    rebind
  },
  data() {
    return {
      title: this.$route.query.title, // 应用列表名
      formData: {}, // 详情数据
      mac_array: '', // 主机MAC
      id: '', // 详情页id
      userData: this.$store.state.login.userData // localStorage用户信息
    };
  },

  created() {
    this.getInfo(this.title);
  },

  computed: {
    time() {
      return this.$uxSdk.time;
    }
  },

  methods: {
    /**
     * 获取信息
     * @param {String} title 唯一标识 id 详情页id userData localStorage用户信息
     */
    getInfo(params) {
      this.$uxLoading.show();
      this.$api.license.getInfo({ title: params }).then((res) => {
        if (res.code == 10000) {
          this.formData = res.data[0];
          this.id = this.formData.id;
          this.mac_array =
            this.formData.tags &&
            JSON.parse(this.formData.tags).macArray &&
            JSON.parse(this.formData.tags).macArray.join(',');
          this.formData.extension = res.data[0].extension && JSON.parse(res.data[0].extension);
        }
      });
    },

    /**
     * 格式化时间
     */
    formatterTime(params) {
      return this.time.format('YYYY-MM-DD', params * 1000);
    },

    /**
     * 续期
     * @param {Object} params 参数
     */
    renewal(params) {
      const title = this.$t('HT.licenseInfo.renewal');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(renewal, {
            props: { data: params }
          });
        },
        confirm: (data) => {
          var now = Date.parse(new Date()) / 1000;
          if (now - params.expire_date > 0) {
            // 判断当前日期是否大于有效期
            if (data.add_date === 0) {
              data.expire_date =
                new Date(Date.parse(data.date.replace(/-/g, '/'))).getTime() / 1000; // 将YYYY-MM-DD 转换为 unix单位
            } else {
              data.expire_date = now + data.add_date * 31536000; // 当前时间加上有效期年份时间
            }
          } else {
            if (data.add_date === 0) {
              data.expire_date =
                new Date(Date.parse(data.date.replace(/-/g, '/'))).getTime() / 1000; // 将YYYY-MM-DD 转换为 unix单位
            } else {
              data.expire_date = params.expire_date + data.add_date * 31536000; // 有效期时间加上新增有效期年份时间
            }
          }
          this.$api.license.renewal(params.id, data).then((res) => {
            if (res.code == 10000) {
              this.$uxModal.hide();
              this.$uxMessage.success(this.$t('HT.addApi.renewalSuccess'));
              this.getInfo(this.title);
            }
          });
        }
      });
    },

    /**
     * 解绑主机
     * @param {Array} mac_array 唯一参数
     */
    rebind(id) {
      const title = this.$t('HT.licenseInfo.unbind');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(rebind, {
            props: { data: this.formData },
            on: {}
          });
        },
        confirm: (data) => {
          let arr = data.mac_array.split(',');
          let list = {};
          list.mac_array = arr;
          if (list.mac_array.length > data.max_hosts) {
            //  主机MAC数与主机数判断
            this.$uxMessage.warning(this.$t('HT.licenseInfo.unbind.warningInfo'));
            return;
          } else {
            this.$uxLoading.show();
            this.$api.license.rebind(id, list).then((res) => {
              if (res.code == 10000) {
                this.$uxModal.hide();
                this.$uxMessage.success(this.$t('HT.addApi.unbindSuccess'));
                this.getInfo(this.title);
              }
            });
          }
        }
      });
    }
  }
};
</script>
<style lang="scss">
.button-space {
  margin-left: 20px;
}
.ux-modal-box {
  overflow: inherit !important;
}
</style>
